import React from 'react';
import { IonPage } from '@ionic/react';
import {
  AppFooter_v2 as AppFooter,
  AppHeader_v2 as AppHeader,
  Button_v2 as Button,
  Container_v2 as Container,
  IconArrowLeft,
  IconButton,
  Typography,
  TypographyVariantsEnum,
} from '@mindly/ui-components';
import { PublicRoutes } from '../../../routes/navigation';
import { useTranslation } from 'react-i18next';
import { Letter3dIcons, useIsKeyBoardShown } from '../../../shared';
import { useSelector } from 'react-redux';
import { signUpEmailSelector } from '../../../redux/auth/selector';

const ForgotSuccess = () => {
  const { t } = useTranslation('auth');
  const isKeyboardShown = useIsKeyBoardShown();

  const signUpEmail = useSelector(signUpEmailSelector);

  return (
    <IonPage>
      <AppHeader>
        <IconButton icon={<IconArrowLeft />} routerLink={PublicRoutes.FORGOT_PASSWORD} />
      </AppHeader>
      <Container isFlexContainer>
        <div className={'flex flex-1 flex-col items-center justify-center gap-2 w-10/12 mx-auto'}>
          <Letter3dIcons />
          <Typography variant={TypographyVariantsEnum.Text24Semi} align={'center'}>
            {t('auth.confirm.email.title')}
          </Typography>
          <Typography variant={TypographyVariantsEnum.Text14Regular} align={'center'} opacity={50}>
            {t('auth.confirm.email.description', { clientEmail: signUpEmail })}
          </Typography>
        </div>
      </Container>
      <AppFooter transparent bottomSaveArea={!isKeyboardShown}>
        <Button fullWidth size={'large'} routerLink={PublicRoutes.PASSWORD}>
          {t('auth.confirm.email.button')}
        </Button>
      </AppFooter>
    </IonPage>
  );
};

export default ForgotSuccess;
